<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fa fa-car" id="ico"></i>
		<h1 style="display:inline-block;">Vehículos</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"></h1>
		</div>
		<div class="mt-3">
			<kt-boton-exportar-tabla [tipoBoton]="'monitoreo'" [nombreArchivo]="'Vahiculos'" [datos]="datosReporte" [buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="vehiculos"
							[showBorders]="true" [rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="5"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-filter-row [visible]="showFilterRow" [applyFilter]="currentFilter"></dxo-filter-row>
							<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="120">
							</dxi-column>
							<dxi-column dataField="imeiFk" alignment="center" caption="Imei">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="placas" alignment="center" caption="Placas" [width]="120">
							</dxi-column>
							<dxi-column dataField="economico" alignment="center" caption="Económico">
							</dxi-column>
							<dxi-column dataField="numeroSerie" alignment="center" caption="Numero Serie">
							</dxi-column>
							<dxi-column dataField="color" alignment="center" caption="Color">
							</dxi-column>
							<dxi-column dataField="descripcion" alignment="center" caption="Descripcion">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="modelo" alignment="center" caption="Modelo">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="anio" caption="Año" alignment="center"
								[calculateFilterExpression]="calculateFilterExpression" [width]="100">
								<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<dx-button valueExpr="id" id="boton" (click)="reportePosiciones(d.data)"><i
										class="fa fa-info" style="text-align: center;"></i></dx-button>
								<dx-button style="background-color: #fff;" class="btnAcciones"
									(click)="ubicarPuntoHistorico(d.data)">
									<i class="fa fa-eye" style="color:#166BA2"></i>
								</dx-button>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
